// keep in sync with test\util\EntityNames.ts
const SYNCHRONIZABLE_ENTITY_DTO = "SYNCHRONIZABLE_ENTITY_DTO";
export const PLAYLIST_LOCAL_STORAGE_ENTITY_NAME: string = `${SYNCHRONIZABLE_ENTITY_DTO}#playlist`;
